import React, { useState } from "react";
import userimg from "../../assets/images/avatar.svg";
import msgActiveimg from "../../assets/images/msg-blue.svg";
import { cardBGColor, getFormattedDate } from "utils";
import JobVerifyOtp from "components/Modals/JobVerifyOtp";
import useCurrentUser from "hooks/useCurrentUser";
import { Link, useNavigate } from "react-router-dom";
import { chatService } from "services/chat.service";
import { toast } from "react-toastify";

const BidCard = ({
    item,
    onShowNegotiate,
    handleAccept,
}) => {
    const { user } = useCurrentUser();
    const navigate = useNavigate();
    const [showVerify, setShowVerify] = useState(false);

    const getJobAmount = () => {
        if (item?.pilotNegotiatedBidAmount) {
            return item?.pilotNegotiatedBidAmount;
        } else if (item?.clientNegotiatedBidAmount) {
            return item?.clientNegotiatedBidAmount;
        } else if (item?.pilotInitialBidAmount) {
            return item?.pilotInitialBidAmount;
        }
    }

    const job = item?.jobId;
    const showButtons = job?.status === "Pending" && item?.pilotInitialBidAmount && item?.clientNegotiatedBidAmount && !item?.pilotNegotiatedBidAmount;

    const getCardBG = () => {
        if (showButtons) return 'skyblue';
        if (job?.status === "PilotAssigned") return 'green';
        return 'bedge';
    }

    const handleCloseVerify = () => {
        setShowVerify(false);
    }

    const onClickSaveJob = () => {
        setShowVerify(true);
    }

    const onChatClick = async (jobId, clientId, pilotId) => {
        try {
            const response = await chatService.startChat({ jobId, clientId, pilotId });
            navigate(`/chat?id=${response?.data?.data?._id}`)
        } catch (err) {
            toast.error(err.data.message);
        }
    }

    return (
        <div className={`job-card ${getCardBG()}-bg`} style={{ minHeight: '400px' }}>
            <div className="d-flex align-items-center gap-2 justify-content-between">
                <div className="d-flex">
                    <img
                        alt="avatar"
                        src={
                            job?.clientId?.avatar
                                ? `${user?.baseS3Url}${job?.clientId?.avatar}`
                                : userimg
                        }
                        className="round-img border border-secondary"
                        onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src = userimg;  // fallback image
                        }}
                    />
                    <p className="mb-0 mt-2 ms-2 dark-textss">{job?.clientId?.fullName}</p>
                </div>
            </div>
            <div className="d-flex justify-content-between mt-2">
                <h3>{job?.title}</h3>
                {getCardBG() === 'bedge' && <p className="pending-bedge mt-2">Pending</p>}
            </div>
            <Link to={`/my-bids/${item?._id}`}>
                <p className="light-texts">Destination</p>
                <address className="dark-textss line-clamp  destination">
                    {job?.address}
                </address>
                <div className="row">
                    <div className="col-lg-6">
                        <div>
                            <p className="light-texts">Required Date</p>
                            <p className="dark-textss">{getFormattedDate(job?.requiredDate)}</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div>
                            <p className="light-texts">Area Size ({job?.areaUnit?.toLowerCase()})</p>
                            <p className="dark-textss">{job?.areaSize}</p>
                        </div>
                    </div>
                </div>

            </Link>
            <div className="footer-card">

                <div className="d-flex justify-content-between align-items-center amount-div">
                    <h5 >{item?.clientNegotiatedBidAmount || job?.status === "PilotAssigned" ? 'Final Approved Amount' : 'Bid Amount'} ($)</h5>
                    <p className="m-0">{getJobAmount()}</p>
                </div>


                {showButtons && (
                    <div className="d-flex">
                        <button className="btn white-btn mt-3" onClick={() => onShowNegotiate(item?._id)}>
                            Negotiate
                        </button>
                        <button className="btn blue-btn ms-3 mt-3" onClick={() => handleAccept(item?._id)}>
                            Accept
                        </button>
                    </div>
                )}
                {job?.status === "PilotAssigned" && (
                    <button className="btn blue-btn w-100 bg-success mt-3" onClick={onClickSaveJob}>
                        Start Job
                    </button>
                )}
            </div>
            <div className="msg-v">
                <img alt="chat" src={msgActiveimg} onClick={() => onChatClick(job?._id, job?.clientId?._id, item?.pilotId?._id)} />
            </div>
            <JobVerifyOtp
                show={showVerify}
                handleClose={handleCloseVerify}
                selectedJobId={job?._id}
            />
        </div>
    );
};

export default BidCard;
